import * as React from "react";
import { App } from "./app"

interface ExtTabGWVm {
    app: App
    buttonID: string
}

// ExtTabGW is a toggle button that either shows or hides the extended info window below a selected item
export class ExtTabGW extends React.Component<ExtTabGWVm, {hoverState: boolean}> {
    constructor(props: ExtTabGWVm) {
        super(props)
    }

    state = {
        hoverState: false
    }

    // Mouse click events trigger the toggle method
    onClick() {
        this.props.app.ToggleExtInfo()
    }

    // Mouse out events affecting the graphics through the hoverstate
    mouseOutHandler(e: React.MouseEvent<HTMLImageElement>) {
        this.setState({ hoverState: false })
    }

    // Mouse over events affecting the graphics through the hoverstate
    mouseOverHandler(e: React.MouseEvent<HTMLImageElement>) {
        this.setState({ hoverState: true })
    }

    // Renders the ext. info toggle button
    render() {
        const imageFileName = "url(images/UtvidetInfoTab.png)"

        // Positioning the image offset, showing different parts depending on states
        var offset = 0

        if (this.state.hoverState == true) {
            offset += 68
        }

        if (this.props.app.state.ExtInfoUp == true) {
            offset += 34
        }

        // turns the offset into a string that will be used to position the background image
        const bgPosition = "0px -" + offset.toString() + "px"

        // Two versions depending on state
        if (this.props.app.state.ExtInfoUp == true) {
            return <div className="tooltipMirrored" style={{}}>
                <div
                    onClick={this.onClick.bind(this)}
                    onMouseOut={this.mouseOutHandler.bind(this)}
                    onMouseOver={this.mouseOverHandler.bind(this)}
                    style={{ cursor: "pointer", width: "80px", height: "34px", backgroundImage: imageFileName, backgroundPosition: bgPosition }} >
                </div>
                <span className="tooltiptext">Skjul utvidet vareinformasjon</span>
            </div>
        }
        else {
            return <div className="tooltipMirrored" style={{}}>
                <div
                    onClick={this.onClick.bind(this)}
                    onMouseOut={this.mouseOutHandler.bind(this)}
                    onMouseOver={this.mouseOverHandler.bind(this)}
                    style={{ cursor: "pointer", width: "80px", height: "34px", backgroundImage: imageFileName, backgroundPosition: bgPosition }} >
                </div>
                <span className="tooltiptext">Utvidet vareinformasjon</span>
            </div>
        }
    }
}



// WEBPACK FOOTER //
// ./client/view/ExtTabGW.tsx